import { useTranslation } from '@mint-lib/i18n';
import { Button, Card, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { LinkOptions, Link as RouterLink } from '@mint/routing';

type ImportHubCardProps = Readonly<{
  title: string;
  description: string;
  linkProps: LinkOptions;
  variant?: 'default' | 'compact';
}>;

export default function ImportHubCard({
  title,
  description,
  linkProps,
  variant = 'default',
}: ImportHubCardProps) {
  const { t } = useTranslation('@myn/import-hub');
  const isCompact = variant === 'compact';

  return (
    <Card
      className="flex h-auto w-[365px] flex-col"
      contentClassName="p-4 h-full flex flex-col justify-between"
    >
      <div className="flex flex-col">
        <h4
          className={cn(
            typographyVariants({
              variant: 'h4',
            }),
            'mb-2',
          )}
        >
          {title}
        </h4>
        <p
          className={cn(
            'text-sm text-text-secondary',
            isCompact ? 'mt-6 pr-15' : 'mt-4 pr-14',
          )}
        >
          {description}
        </p>
      </div>
      <div className="mt-3 flex items-center justify-between">
        <div className="flex grow justify-end">
          <Button asChild variant="outlined" data-dd-action-name="View">
            <RouterLink {...linkProps}>{t('View')}</RouterLink>
          </Button>
        </div>
      </div>
    </Card>
  );
}
